import React from "react";
import AboutUs from "../components/AboutUs/AboutUs";

const About = () => {
  return (<AboutUs companyName="Arctic Books"/>)};

export default About;
